import { orgCompositionsHoldsUrl } from '../urls';
import refresh from '../refresh';

export async function postOrgCompositionHold(orgId, compId, type, message) {
  const data = {
    org: orgId,
    comp: compId,
    type,
    message,
  };
  return refresh(async () => {
    const response = await fetch(orgCompositionsHoldsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}

export async function deleteOrgCompositionHold(orgId, compId, type) {
  const data = {
    org: orgId,
    comp: compId,
    type,
  };
  return refresh(async () => {
    const response = await fetch(orgCompositionsHoldsUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
